exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#app{font-family:effra,Helvetica,Arial,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-align:center;color:#3c515b;margin-top:60px}h1,h2{font-weight:400}ul{list-style-type:none;padding:0}li{display:inline-block;margin:0 10px}a{color:#fd4974}header{position:fixed;top:0;width:100%;min-height:90px;text-align:center}main{display:flex;height:calc(100vh - 90px);max-width:1200px;margin-top:90px;margin-left:auto;margin-right:auto;overflow:hidden}aside{flex:1 0 30%;height:100%;overflow-y:auto;width:30%;padding:50px 30px;box-sizing:border-box;text-align:left}.content{flex:1 1 70%;display:flex;align-items:center;justify-content:center}.link{display:block;text-decoration:none;margin-bottom:10px;color:#2c3e50}.link--home{text-transform:uppercase;margin-bottom:30px}.link.is-active{color:#fd4974}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b08e9b4a","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 23
// module chunks = 0